// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2222":"11ac460a","4420":"fc38bd53","4744":"88ded690"}[chunkId] + ".chunk.css";
};